import apiService from "../../services/apiService";
import { storageService } from "../../services/storageService";

export interface RegisterDeviceRequest {
  fcmToken: string;
  deviceType: "WEB";
}

// localStorage key holding the FCM device token (FID) for the signed-in browser.
// Note: persisted so we can send it in the logout request body — the server
// needs the exact token to delete just THIS device's row, not all of the user's.
export const FCM_DEVICE_TOKEN_KEY = "fcmDeviceToken";

// Reads the FCM device token stored at register time (null if never registered).
export const getStoredDeviceToken = (): string | null =>
  storageService.getItem(FCM_DEVICE_TOKEN_KEY);

// Clears the stored FCM device token (call after it has been sent for removal).
export const clearStoredDeviceToken = (): void =>
  storageService.removeItem(FCM_DEVICE_TOKEN_KEY);

// POST /api/notifications/device-token — stores the FCM device token for the
// signed-in user so the backend can push to this browser.
// Note: on success we persist the token client-side so logout can pass it back
// for removal from the DB.
export const registerNotificationDevice = async (request: RegisterDeviceRequest) => {
  const response = await apiService.post("api/notifications/device-token", request);
  storageService.setItem(FCM_DEVICE_TOKEN_KEY, request.fcmToken);
  return response;
};
